import { Grid2 as Grid, Typography } from '@mui/material';
import format1_download from '../_img/format1_download.png';
import { TypographyStepTitle } from '../style/typography';

const ImageDisplay = ({ src, alt }) => (
  <img src={src} alt={alt} style={{ width: '100%', height: '100%' }} />
);

const Caution = ({ title, alt }) => {
    return (
        <Grid size={{ xs: 12 }}>
            <Grid container size={{ xs: 12 }} spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <TypographyStepTitle>
                        {title}
                    </TypographyStepTitle>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography sx={{ marginTop: 2 }}>
                        部署名が変更されると、以下の箇所に影響を与える可能性があります。
                    </Typography>
                </Grid>
                <ImageDisplay src={format1_download} alt={alt} />
            </Grid>
        </Grid>
    );
};

export default Caution;